<template>
  <div class="wrapper">

    <div class="row">
      <div class="col-12">
        <h3 v-if="course.title && course.title.length">
          {{ course.title }}
          <br>
          "Peace Work in Transformation"- ASPR 40-jähriges Jubiläum Festakt und Konferenz; 3-5 Oktober 2022
        </h3>
      </div>
    </div>

    <form action="#">

      <!-- User: -->
      <div class="form-label" style="margin: 30px 0 0; font-weight: bold;">Personal Information / Persönliche Angaben</div>
      <div class="form-section">
        <div class="row">
          <v-input v-model="user.vorname" name="user.vorname" label="First Name / Vorname" :required="true"></v-input>
          <v-input v-model="user.nachname" name="user.nachname" label="Last Name / Nachname" :required="true"></v-input>
        </div>

        <div class="row">
          <v-input v-model="user.company" name="user.company" label="Organisation"></v-input>
          <v-input v-model="user.position" name="user.position" label="Position"></v-input>
        </div>

        <div class="row">
          <v-input v-model="user.email" name="user.email" label="E-mail" type="email" :required="true"></v-input>
          <v-input v-model="user.phone" name="user.phone" label="Phone no. / Telefonnummer" :required="true"></v-input>
        </div>
      </div>

      <!-- Options.package: -->
      <div class="form-section">
        <div class="row">
          <div class="col-12">
            <div class="form-label" style="margin: 30px 0 0; font-weight: bold;">Events / Veranstaltungen</div>
            <div class="input-wrapper" :class="{error: anniversary.errors.has('options.package')}">
              <div class="form-label">I will be participating in all events / Ich nehme an allen Veranstaltungen teil *</div>

              <v-radio @input="val => options.package = val" styleclass="inline-elements" name="options.package" type="radio" label="Yes. / Ja." value="1"></v-radio>
              <v-radio @input="val => options.package = val" styleclass="inline-elements" name="options.package" type="radio" label="No. / Nein." value="0"></v-radio>
              <span v-if="anniversary.errors.has('options.package')" class="error-msg">{{ anniversary.errors.get('options.package') }}</span>
            </div>
          </div>
        </div>
      </div>

        <!-- Options.tagen -->
        <template v-if="options.package === '0'">
          <div v-bind:class="{ deactivated: showAdditionalFields  }" class="form-section">
            <div class="row">
              <div class="col-12">
                <div class="input-wrapper" :class="{error: anniversary.errors.has('options.tagen')}">

                    <div v-for="day in termine.days" :key="day.id" class="input-single">
                      <label class="radio-label">
                        <input v-model="options.tagen" type="checkbox" :value="day.id" :disabled="showAdditionalFields">
                        {{day.date}}:
                        {{ day.title }}
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <span v-if="anniversary.errors.has('options.tagen')" class="error-msg">{{ anniversary.errors.get('options.tagen') }}</span>

                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- Options.shuttle -->
        <div class="form-section">
          <div class="row">
            <div class="col-12">
              <div class="form-label" style="margin: 30px 0 0; font-weight: bold;">Shuttle Service / Transfers</div>
              <div class="input-wrapper" :class="{error: anniversary.errors.has('options.shuttleArrival')}">
                <div class="form-label">ARRIVAL / ANREISE *</div>
                <v-radio @input="val => options.shuttleArrival = val" styleclass="" name="options.shuttleArrival" type="radio" label="I will be arriving in my own vehicle on (date and time) / Ich reise in meinem eigenen Fahrzeug an (Datum und Uhrzeit)" value="1"></v-radio>
                <div class="row" v-if="options.shuttleArrival == 1">
                  <div class="col-md-6" style="margin-top: -15px; margin-bottom: 25px;">
                    <v-input v-model="options.shuttleArrivalOn" placeholder="date and time / Datum und Uhrzeit" columnclass="" name="options.shuttleArrivalOn" label=""></v-input>
                  </div>
                </div>
                <v-radio @input="val => options.shuttleArrival = val" styleclass="" name="options.shuttleArrival" type="radio" label="Shuttle Service from Vienna (Central Station) on the 3rd of October / Transfer von Wien (Hauptbahnhof) am 3. Oktober" value="2"></v-radio>
                <v-radio @input="val => options.shuttleArrival = val" styleclass="" name="options.shuttleArrival" type="radio" label="Shuttle Service from Vienna (Central Station) on the 4th of October / Transfer von Wien (Hauptbahnhof) am 4. Oktober" value="3"></v-radio>
                <span v-if="anniversary.errors.has('options.shuttleArrival')" class="error-msg">{{ anniversary.errors.get('options.shuttleArrival') }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="input-wrapper" :class="{error: anniversary.errors.has('options.shuttleDeparture')}">
                <div class="form-label">DEPARTURE / ABREISE *</div>
                <v-radio @input="val => options.shuttleDeparture = val" styleclass="" name="options.shuttleDeparture" type="radio" label="I will be departing in my own vehicle on (date and time) / Ich reise mit meinem eigenen Fahrzeug ab (Datum und Uhrzeit)" value="1"></v-radio>
                <div class="row" v-if="options.shuttleDeparture == 1">
                  <div class="col-md-6" style="margin-top: -15px; margin-bottom: 25px;">
                    <v-input v-model="options.shuttleDepartureOn" placeholder="date and time / Datum und Uhrzeit" columnclass="" name="options.shuttleDepartureOn" label=""></v-input>
                  </div>
                </div>
                <v-radio @input="val => options.shuttleDeparture = val" styleclass="" name="options.shuttleDeparture" type="radio" label="Shuttle Service from Schlaining to Vienna on the 5th of October / Transfer Schlaining-Wien am 5. Oktober" value="2"></v-radio>
                <span v-if="anniversary.errors.has('options.shuttleDeparture')" class="error-msg">{{ anniversary.errors.get('options.shuttleDeparture') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Options.nutrition -->
        <div class="form-section">
          <div class="row">
            <div class="col-md-12">
              <div class="form-label" style="margin: 30px 0 0; font-weight: bold;">Dietary Restrictions / Nahrungsmittelunverträglichkeiten *</div>
            </div>
            <v-input v-model="options.nutrition" columnclass="col-md-12" name="options.nutrition" labelclass="text-normal" label="We will do our best to accommodate your dietary restrictions
              in case of food allergies or sensitives. Should you have any special dietary requirements please let us know in the field below.
              / Wir tun unser Bestes, um Ihre Nahrungsmitteleinschränkungen im Falle von Lebensmittelallergien oder Unverträglichkeiten zu
              berücksichtigen. Teilen Sie uns diese bitte in dem unten stehenden Feld mit."></v-input>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <br>
            <hr>
            <br>
          </div>
        </div>

      <!-- GDPR -->
      <div class="form-section">
        <div class="row">
          <div class="col-12">
            <div>
              <v-checkbox v-model="user.gdprnews" name="user.gdprnews" label="Please send me the ASPR News and relevant
                information about future ASPR events. I understand that my personal data will be processed and stored
                in accordance with the General Data Protection Regulation of the European Union and that I may revoke
                my consent any time. / Bitte senden Sie mir die ASPR News und relevante Informationen über zukünftige
                ASPR Veranstaltungen. Mir ist bekannt, dass meine persönlichen Daten in Übereinstimmung mit der
                Allgemeinen Datenschutzverordnung der Europäischen Union verarbeitet und gespeichert werden und dass
                ich meine Einwilligung jederzeit widerrufen kann." :required="false"></v-checkbox>
            </div>
          </div>

          <div class="col-12">
            <div class="input-wrapper">
              <v-checkbox v-model="user.gdprdaten" name="user.gdprdaten" label="I understand that my personal data
                will be processed and stored for the purposes of the event in accordance with the
                <a href='/datenschutz/' target='_blank' rel='noopener'>
                General Data Protection Regulation</a> of the European Union.* / Mir ist bekannt, dass meine
                personenbezogenen Daten für die Zwecke der Veranstaltung gemäß der
                <a href='/datenschutz/' target='_blank' rel='noopener'>Allgemeinen Datenschutzverordnung</a>
                der Europäischen Union  verarbeitet und gespeichert werden." :required="true"></v-checkbox>
            </div>
          </div>

          <div class="col-12">
            <div class="input-wrapper">
              <v-checkbox v-model="user.gdprstorno" name="user.gdprstorno" label="I have read and accept the
                <a href='/geschaefts-und-stornobedingungen/' target='_blank' rel='noopener'>terms and conditions</a>.* /
                Ich habe die  <a href='/geschaefts-und-stornobedingungen/' target='_blank' rel='noopener'>Allgemeinen
                Geschäftsbedingungen</a> gelesen und akzeptiere diese." :required="true"></v-checkbox>
            </div>
          </div>
        </div>

      </div>

      <!-- Submit: -->
      <div class="row">
        <div class="col-lg-3 col-md-4 col-12">
          <div class="input-wrapper">
            <button @click.prevent="submit" class="btn-submit" style="display:flex">
              <span>APPLY / ANMELDEN</span>
              <span class="arrow"></span>
            </button>
          </div>
        </div>
      </div>

    </form>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import VInput from './fields/VInput'
import VCheckbox from './fields/VCheckbox'
import VRadio from './fields/VRadio'

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('anniversary')

export default {
  name: 'Form',
  components: {
    VInput,
    VCheckbox,
    VRadio
  },

  data () {
    return {
      user: {
        vorname: '',
        nachname: '',
        email: '',
        phone: '',
        company: '',
        position: '',
        gdprnews: '',
        gdprstorno: '',
        gdprdaten: ''
      },
      options: {
        tagen: [],
        package: null,
        shuttleArrival: null,
        shuttleDeparture: null,
        shuttleArrivalOn: '',
        shuttleDepartureOn: '',
        nutrition: ''
      }
    }
  },

  computed: {
    ...mapGetters(['showAdditionalFields']),
    ...mapState(['anniversary', 'termine', 'course']),
    selectedPackage () {
      return this.options.package
    }
  },

  created () {
    this.fetchCourse()
  },

  methods: {
    ...mapActions(['updateUser', 'updateOptions', 'sendForm', 'fetchCourse']),
    async submit () {
      var response = await this.sendForm()
      response.success && this.$router.push('thankyou')
    }
  },

  watch: {
    user: {
      handler: function (val) {
        this.updateUser({
          user: val
        })
      },
      deep: true
    },
    options: {
      handler: function (val) {
        this.updateOptions({
          options: val
        })
      },
      deep: true
    },
    selectedPackage: {
      handler: function (val) {
        this.$nextTick(() => {
          const tagen = this.termine.days.map(day => day.id)
          this.options.tagen = (val === '1') ? tagen : []
        })
      }
    }
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .input-wrapper {
        &.error {
            input {
                border-color: #c2063b;
            }
        }

        .error-msg {
            color: #c2063b;
            font-size: 15px;
            display: block;
        }
    }
</style>
